import { render, staticRenderFns } from "./CommSettingsSection.vue?vue&type=template&id=6f5d18fa&scoped=true&"
import script from "./CommSettingsSection.vue?vue&type=script&lang=ts&"
export * from "./CommSettingsSection.vue?vue&type=script&lang=ts&"
import style0 from "./CommSettingsSection.vue?vue&type=style&index=0&id=6f5d18fa&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d18fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
